import React, { useEffect } from "react";

const Hero = () => {
	return (
		<div className="lg:max-w-7xl mx-auto  pt-16 ">
			<div className="grid sm:grid-cols-1  lg:grid-cols-2 md:grid-cols-2 md:p-16 p-5  gap-5 lg:py-20">
				<div className="lg:mt-16 sm:mt-0 md:p-0" data-aos="zoom-out">
					<h1 className="text-white lg:text-[5rem] text-[3rem] md:text-6xl font-semibold leading-[1.10] mb-5 lg:mb-10">
						YOUR
						<span className="pl-2 text-transparent bg-clip-text bg-gradient-to-r from-rose-400 via-fuchsia-500 to-indigo-500">
							WEB3.0
						</span>
						<br />
						JOURNEY BEGINS HERE
					</h1>
					<span className="text-gray-400 md:text-xs lg:text-lg leading-normal  ">
						Medusa is a non-fungible token on the Solana blockchain with a
						collection size of 7777 randomly generated unique pieces with more
						than 150 traits.
					</span>
					<br />
					<a href="https://ephemeral-gingersnap-64ff92.netlify.app/">
						<button className="text-md lg:text-2xl mt-5 lg:mt-10 bg-white p-2 mb-5 lg:mb-0 lg:p-5 font-extrabold text-white bg-gradient-to-r from-fuchsia-400 to-rose-500 rounded-lg">
							MINT NOW
						</button>
					</a>
				</div>
				<div className="h-[600px]" data-aos="zoom-out">
					<img
						className=" sm:object-cover md:object-cover"
						src={"./hand.png"}
					/>
				</div>
			</div>
		</div>
	);
};

export default Hero;
